export interface BottomItem {
  icon?: React.ReactNode;
  content: React.ReactNode;
  url?: string;
}

export interface BottomProps {
  prefixCls?: string;
  title?: string;
  items: BottomItem[];
}
export default function Bottom(props: BottomProps) {
  const { title, items, prefixCls } = props;

  return (
    <div className={`${prefixCls}-bottom-container`}>
      <h2 className={`${prefixCls}-bottom-title`}>{title}</h2>
      {/* The order of items seem not to be changed so using index as their key is okay */}
      {items.map((item, index) => (
        <p key={index} className={`${prefixCls}-bottom-item`}>
          <i>{item.icon}</i>
          {item.content}
        </p>
      ))}
    </div>
  );
}
